import { z } from 'zod';

const envSchema = z.object({
  VITE_API_BASE_URL: z.string().default(''),
  VITE_ENABLE_DS_PREVIEW: z
    .enum(['true', 'false'])
    .default('false')
    .transform((value) => value === 'true'),
});

function parseEnv() {
  const result = envSchema.safeParse(import.meta.env);

  if (!result.success) {
    const message = result.error.issues.map((issue) => issue.message).join('; ');
    throw new Error(`Invalid environment configuration: ${message}`);
  }

  return result.data;
}

export const env = parseEnv();
